import { render, staticRenderFns } from "./binding3.vue?vue&type=template&id=74737019&scoped=true&"
import script from "./binding3.vue?vue&type=script&lang=js&"
export * from "./binding3.vue?vue&type=script&lang=js&"
import style0 from "./binding3.vue?vue&type=style&index=0&id=74737019&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74737019",
  null
  
)

export default component.exports